import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonIcon, IonLabel, IonNote, IonRow, 
	IonSlides, IonSlide, IonItem, IonThumbnail, IonImg, useIonToast,
	useIonModal,
	IonToolbar,
	IonHeader,
	IonCard,
	IonFooter,
	IonPage
} from '@ionic/react';
import { globeOutline, heart, heartOutline, locationOutline, navigateOutline, phonePortraitOutline, closeOutline,  
	idCardOutline, cameraOutline, information, pricetagOutline, mailOutline,
	chevronBackOutline, desktopOutline, copySharp, callOutline, logoWhatsapp } from "ionicons/icons";
import { useState, useRef, useEffect } from 'react';

import { Clipboard } from "@capacitor/clipboard";

import { Capacitor } from '@capacitor/core';
//import { Browser } from '@capacitor/browser';

import { addToFavourites, FavouritesStore } from "../data/FavouritesStore";

import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper core and required modules
import { Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom  } from "swiper/modules";

import 'swiper/css';
import '@ionic/react/css/ionic-swiper.css';
import "swiper/css/navigation";
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';

import { SwiperZoomModal } from '../components/SwiperZoomModal';

export const MarkerInfoWindow = ({marker, onDismiss, history}) => {

	const baseUrl = `${process.env.REACT_APP_BASE_URL}`;
	const webUrl = `${process.env.REACT_APP_WEB_URL}`;

	const favourites = FavouritesStore.useState(s => s.product_ids);
	const [isFavourite, setIsFavourite] = useState(false);
	useEffect(() => {
        const tempIsFavourite = favourites.find(f => f === `${ marker.sale_type }/${ marker.id }`);
        setIsFavourite(tempIsFavourite ? true : false);
    }, [marker, favourites]);


	let photos = marker?.photos || [];

	let env = `${process.env.REACT_APP_ENVIRONMENT}`;
	var images = photos.map((image, i) => {
		return { src: env == 'staging' ? baseUrl + image.photo : image.photo, text: image.caption }
	});

	if (env == 'development') {

		images = [
			{ src: 'assets/repics/1.jpg' },
			{ src: 'assets/repics/2.jpg' },
			{ src: 'assets/repics/3.jpg'},
			{ src: 'assets/repics/5.jpg' },
			{ src: 'assets/repics/4.jpg' }
		]
	
	}

	const zoomModalDismiss = () => {
		dismissZoomModal();
	}
	
	const [clickedImageKey, setClickedImageKey ] = useState(0);

	const [presentZoomModal, dismissZoomModal] = useIonModal(SwiperZoomModal, { zoomModalDismiss, images, clickedImageKey });

	function slideClick(imgKey){
	
		setClickedImageKey(imgKey);

		presentZoomModal({
			initialBreakpoint: 1,
			breakpoints: [0,1],
			backdropBreakpoint: 0,
			animated: true,
			swipToClose: true,
			cssClass: 'modal-fullscreen'
		});
	}

	const openDetails = async (url) => {
        //await Browser.open({ baseUrl +'/'+ url });
		if (Capacitor.isNativePlatform()) {
            history.push(url);
			onDismiss('onlyDismiss');
        } else {
            //window.open(url, '_blank');
			history.push(url);
			onDismiss('onlyDismiss');
        }
    };

	const [presentToast] = useIonToast();
	const copyToClipboard = async (text) => {
			try {
				await Clipboard.write({
					string: text
				});
				presentToast({
					message: 'Copied to clipboard.',
					duration: 3000,
					color: 'success'
				});
			} catch (err) {
				console.error('Failed to copy text:', err);
				presentToast({
					message: 'Failed to copy text to clipboard.',
					duration: 3000,
					color: 'danger'
				});
			}
		};

	let msgTextBody = `Hello,%0a I am interested in the property "${marker?.title}" listed on %0a ${webUrl}/markerdetails/${marker?.slug} %0a`;

	const productCartRef = useRef();
    const productFavouriteRef = useRef();

	const addProductToFavourites = (e, marker) => {

        e.preventDefault();
        e.stopPropagation();
        addToFavourites(marker);


        productFavouriteRef.current.style.display = "";
        productFavouriteRef.current.classList.add("animate__fadeOutTopRight");

        setTimeout(() => {
            if (productCartRef.current) {
                productFavouriteRef.current.classList.remove("animate__fadeOutTopRight");
                productFavouriteRef.current.style.display = "none";
            }
        }, 500);
    }

	return (
		<>
			<IonContent>
				<IonGrid>
					<IonRow className="ion-margin-bottom">
						<IonCol size="10">
							<IonLabel>
								<h1>{marker?.title}</h1>
								<IonNote>{marker?.property_type}</IonNote>
							</IonLabel>
						</IonCol>
						<IonCol size="1">
							<IonIcon color={ isFavourite ? "danger" : "medium" } 
								icon={ isFavourite ? heart : heartOutline } onClick={ e => addProductToFavourites(e, marker) } />
							<IonIcon ref={ productFavouriteRef } style={{ position: "absolute", display: "none" }} 
								className={ `animate__animated` } color="danger" icon={ heart } />
						</IonCol>
						<IonCol size="1">
							<IonIcon className="ion-float-right" icon={closeOutline} onClick={() => onDismiss()}/>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<Swiper 
								modules={[Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom]}
								autoplay={true}
								navigation={true}
								slidesPerView={2.5} initialSlide= {2} speed={400} spaceBetween= {10} centeredSlides={true} 
								zoom={true}
								loop={true}>
								{images.map((image, i) => {
									if(!image.src.includes('undefined')) { 
										return <SwiperSlide key={i} onClick={() => slideClick(i)}>
											<div className="swiper-zoom-container">
											
											<IonImg src={image.src} />
											
											{/*<IonLabel>{image.text}</IonLabel>*/}
											
											</div>
										</SwiperSlide>
									}
								})}
							</Swiper>
						</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start">
						<IonCol size="1">
							<IonIcon icon={information} color="drukre" style={{fontSize: "1.5rem"}} />
						</IonCol>
						<IonCol size="11">
							<div style={{ whiteSpace: "pre-wrap", userSelect: "text", WebkitUserSelect: "text" }}>
								{marker?.description}
							</div>
						</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="1">
							<IonIcon icon={locationOutline} color="drukre" style={{fontSize: "1.5rem"}} />
						</IonCol>
						<IonCol size="11">{marker?.address}</IonCol>
					</IonRow>

					<IonRow className="ion-justify-content-start ion-align-items-center">
						<IonCol size="1">
							<IonIcon icon={pricetagOutline} color="drukre" style={{fontSize: "1.5rem"}} />
						</IonCol>
						{/* Price: format to Bhutanese currency */}
						<IonCol size="11">Nu. {marker?.price?.toLocaleString('en-IN')}</IonCol>
					</IonRow>

					{marker?.show_names_emails && (
						<>
							{marker?.additional_contact_info && (
								<IonRow className="ion-justify-content-start ion-align-items-center">
									<IonCol size="1">
										<IonIcon icon={phonePortraitOutline} color="drukre" style={{ fontSize: "1.5rem" }} />
									</IonCol>
									<IonCol size="5">
										{marker?.additional_contact_info}
									</IonCol>
									<IonCol size="6" className="ion-text-right">
										<IonButton className="ion-padding-start" href={`tel:${marker?.additional_contact_info}`} title="Call"><IonIcon icon={callOutline} /></IonButton>
										{marker?.additional_contact_info.includes('+') ? (
												<IonButton href={`https://wa.me/${marker?.additional_contact_info}?text=${msgTextBody}`} target="_blank" title="WhatsApp"><IonIcon icon={logoWhatsapp} /></IonButton>
											) : marker?.additional_contact_info.length === 8 ? (
												<IonButton href={`https://wa.me/+975${marker?.additional_contact_info}?text=${msgTextBody}`} target="_blank" title="WhatsApp"><IonIcon icon={logoWhatsapp} /></IonButton>
											) : <IonButton href={`https://wa.me/${marker?.additional_contact_info}?text=${msgTextBody}`}  target="_blank" title="WhatsApp"><IonIcon icon={logoWhatsapp} /></IonButton>
										}
										<IonButton title='Copy Phone Number' mode="md" onClick={() => copyToClipboard(marker?.additional_contact_info)}> <IonIcon icon={copySharp} /></IonButton>
									</IonCol>
								</IonRow>
							)}
							{/*Search realtor_emails array for tttwangchuk@gmail.com and skip*/}
							{marker?.realtor_emails && !marker?.realtor_emails.includes('tttwangchuk@gmail.com') && (
								<IonRow className="ion-justify-content-start ion-align-items-center">
									<IonCol size="1">
										<IonIcon icon={mailOutline} color="drukre" style={{ fontSize: "1.5rem" }} />
									</IonCol>
									<IonCol size="11">{marker?.realtor_emails}</IonCol>
								</IonRow>
							)}
						</>
					)}
				</IonGrid>
				<IonToolbar
					style={{
						position: 'sticky',
						bottom: 0,
						left: 0,
						right: 0,
						zIndex: 1000,
						background: 'var(--ion-background-color)'
					}}
				>
					<IonRow>
						<IonCol size="2">
							<IonButton color="light" onClick={() => onDismiss()}>
								<IonIcon icon={chevronBackOutline} />
							</IonButton>
						</IonCol>
						<IonCol size="4" className="ion-text-center">
							{marker?.price ?
								<IonItem>Nu. {marker.price?.toLocaleString('en-IN')}</IonItem>
								: null
							}
						</IonCol>
						<IonCol size="6" className="ion-text-right">
							<IonButton fill="outline" color="drukre" onClick={() => openDetails('/markerdetails/' + marker?.slug)}>
								<IonIcon icon={navigateOutline} />&nbsp;
								Details
							</IonButton>
						</IonCol>
					</IonRow>
				</IonToolbar>
			</IonContent>
		</>
	);
}